// extracted by mini-css-extract-plugin
export default {"about":"about_about__k62nO","about_container":"about_about_container__qrgAO","img_wrapper":"about_img_wrapper__kbi3e"};